module.exports = __webpack_public_path__ + "static/rocket_logo_black-2a07f4bfc0fe5802fc062f8124bdbd21.png";